export type SchedulingFieldKey = "schedstart" | "schedfinish" | "actstart" | "actfinish";

export const isSchedulingFieldEditable = (fieldKey: string, canEditWorkOrderFields: boolean, isEditMode: boolean) => {
  const schedulingFieldKeys: SchedulingFieldKey[] = ["schedstart", "schedfinish", "actstart", "actfinish"];

  if (!canEditWorkOrderFields) {
    return false;
  }

  if (schedulingFieldKeys.includes(fieldKey as SchedulingFieldKey)) {
    return true;
  }

  return isEditMode;
};
